module.exports = __webpack_public_path__ + "media/When Faith is Lost.44d3eef6.mp3";